import type { definitions } from '@luxuryescapes/contract-search'
import { getCurrentIntl } from 'i18n/util/currentIntl'

export function tourV2PopularDestinationMap(
  trendingDestination: definitions['toursSearchTrendingDestinations'],
): App.SearchDestination {
  const intl = getCurrentIntl()
  return {
    destinationType: trendingDestination.placeType,
    format: {
      mainText: trendingDestination.destinationName,
      secondaryText: trendingDestination.count > 0 ? intl.formatMessage({
        id: 'vZynff31PUIX-I43gpnp',
        defaultMessage: '{count, plural, one {# offer} other {# offers}} available',
        description: 'Tour search trending destination available offer count',
      }, { count: trendingDestination.count }) : undefined,
    },
    searchType: 'destination',
    value: trendingDestination.placeIds.join(','),
    imageId: trendingDestination.imageId,
  }
}
